module.exports = __webpack_public_path__ + "img/send-green-big.cc76cbb2.svg";